import BOOKABLE_SERVICE_BUNDLE_CONFIG from '../../metadata/statsig/BOOKABLE_SERVICE_BUNDLE_CONFIG.json';

/**
 * @returns True if bookable bundles are currently enabled in our system.
 */
export default function areBookableBundlesEnabled(): boolean {
  return BOOKABLE_SERVICE_BUNDLE_CONFIG.shouldUseNewBookableBundleConfigs;
}
